import "./CameraConfigurations.html";

import "./EditCareFunctionality/EditCareFunctionalityComponent";
import "./EditFlameDetectionFunctionality/EditFlameDetectionFunctionalityComponent";
import "./EditMotionDetectionFunctionality/EditMotionDetectionFunctionalityComponent";
import "./EditRecordingFunctionality/EditRecordingFunctionalityComponent";
import "./EditVideoStream/EditVideoStreamComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import CameraConfigurationsComponentController from "./CameraConfigurationsComponentController";

export default class CameraConfigurationsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            isEditable: "=",
            isSidebarCollapsed: "<",
            siteEquipment: "<",
            siteId: "<",
        };
        this.controller = CameraConfigurationsComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/" +
            "SelectedEquipment/CameraConfigurations/CameraConfigurations.html";
    }
}

module("mmManagePortal").component("mmCameraConfigurations", new CameraConfigurationsComponent());
